import service from '../request'
const baseUrl = `${window.globalUrl.HOME_API_WEI}/trade-website/`;

//农服商统计接口
export const selectCompanyStatistics = (params) => {
  return service({
    method: 'get',
    url: baseUrl + `selectCompanyStatistics`,
    params: params
  })
}

/**
 * 在线农机列表
 * @param {*} params
 */
export const onlineMachineryList = (params) => {
  return service({
    method: 'get',
    url: baseUrl + `onlineMachineryList`,
    params: params
  })
}

/**
 * 获取经营主体数据
 */
export const getBusinessList = (params) => service({
  method: 'get',
  url: baseUrl + `getBusinessList`,
  params: params
})

/**
 * 大屏中间统计数据
 * @param {*} params
 * @returns
 */
export const selectStatisticsMiddle = (params) => {
  return service({
    method: 'get',
    url: baseUrl + `selectStatisticsMiddle`,
    params: params
  })
}

/**
 * 大屏左侧统计数据
 * @param {*} params
 * @returns
 */
export const selectStatisticsLeft = (params) => {
  return service({
    method: 'get',
    url: baseUrl + `selectStatisticsLeft`,
    params: params
  })
}

/**
 * 免费代理记账 在线贷款信息  统计图数据
 * @param {*} params
 * @returns
 */
export const creditAndAccount = (params) => {
  return service({
    method: 'get',
    url: baseUrl + `creditAndAccount`,
    params: params
  })
}

/**
 * 获取大屏土地流转热力图数据
 * @param {*} params
 * @returns
 */
export const getHeatMapData = (params) => {
  return service({
    method: 'get',
    url: baseUrl + `getHeatMapData`,
    params: params
  })
}
